<!-- Translated: yes -->
<template>
  <div :class="type + '-wrapper ' + (valuebinder === value ? 'active' : '') + (below ? ' below' : '') + (disabled ? ' disabled' : '') + (specialClass ? ' ' + specialClass : '')" @click="updateValue">
    <span>
      <label :class="labelPosition" v-if="labelPosition === 'before' || labelPosition === 'left'">{{label}}<span class="sublabel" v-if="sublabel">{{sublabel}}</span></label>
      <span class="the-graphics" :style="style"></span>
      <label :class="labelPosition" v-if="labelPosition === 'after'" style="display:block;text-align:center;margin-top: 2px;">{{label}}<span class="sublabel" v-if="sublabel">{{sublabel}}</span></label>
      <label :class="labelPosition" v-if="labelPosition === 'right'">{{label}}<span class="sublabel" v-if="sublabel">{{sublabel}}</span></label>
    </span>
  </div>
</template>

<script>
export default {
  template: '#radio-wrapper',
  props: {
    valuebinder: {},
    value: {},
    label: {},
    labelPosition: {
      default: 'before',
    },
    type: {
      default: 'radio',
    },
    color: {
      default: 'blue',
    },
    sublabel: {
      default: '',
    },
    size: {
      default: 22,
    },
    below: {
      default: false,
    },
    disabled: {
      default: false,
    },
    specialClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  methods: {
    updateValue(e) {
      if (this.value === this.valuebinder) {
        this.$emit('update:valuebinder', null);
      } else {
        this.$emit('update:valuebinder', this.value);
      }
      this.$emit('click', e);
      this.$emit('clicked', e);
    },
  },
  computed: {
    style() {
      if (this.valuebinder === this.value) {
        return `background-image: url("https://static.booking.branasgruppen.se/static/svg/check-${this.color}.svg");width:${this.size}px;height:${this.size}px;`;
      }
      return `width:${this.size}px;height:${this.size}px;`;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

label
  display inline-block

.left
  float: none;
  padding-top: 5px;

.radio-wrapper,
.checkbox-wrapper
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 0.3px;
  text-align: left;
  color: #262626;
  text-transform: uppercase;
  display: inline-block;
  border-radius: 50%;
  // background-color: #ffffff;
  // border: solid 1px #ecf5f8;
  //padding: 8px 13px;
  //margin-right: 10px;
  margin-left 0
  cursor: pointer;
  & > span
    text-align: center
    display: inline-block;
  .the-graphics
    display:inline-block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #ffffff;
    border: solid 1px #bfd9e1;
    margin-left: 0;
    margin-right: 0;
    vertical-align: middle;
    background-color:white;
    border-radius: 50%;
    transition: all 0.2s
    @media (any-hover: hover)
      &:hover
        background-color: lighten(#bfd9e1, 50%);
  &.active .the-graphics
    background-color: #ffffff;
    position: relative;
    z-index:2;
    /*width: 18px;
    height: 18px;
    margin-top:2px;
    margin-bottom:2px;
    margin-right:2px;
    margin-left:9px;*/
    background-image: url('https://static.booking.branasgruppen.se/static/svg/check-blue.svg');
    background-repeat no-repeat;
    background-size: cover;
    background-size 100%;
    background-position: center;
    @media (any-hover: hover)
      &:hover
        opacity 0.6

.sublabel
  font-weight normal
  display block
  color #999999

.checkbox-wrapper
  border-radius: 4px;
  .the-graphics
    border-radius: 2px;
  &.active .the-graphics
    background-size 80%;

.error.radio-wrapper,
.error.checkbox-wrapper
  color warning
  .the-graphics
    border-color warning

.disabled
  disabled()

.radio-wrapper.below
  width 42%
  margin-left 4%
  margin-right 4%
  &.active .the-graphics
    background-image: url('https://static.booking.branasgruppen.se/static/svg/check-blue 2.svg') !important;

  .sublabel
    color #111111
    text-transform none
    font-size: 1em
    margin-top: 0.5rem;
    font-weight: 300;
    font-size 13px

.radio-wrapper
  &.rental-user
    color white
    margin-right 0.5rem
    margin-left 0.5rem

    & > span
      display flex
      align-items center

    label
      margin-bottom: 0
      margin-left 0.25rem

  &.skipass-user
    color inherit
    margin-right 0.5rem
    margin-left 0.5rem

    & > span
      display flex
      align-items center

    label
      margin-bottom: 0
      margin-left 0.25rem

.wishes
  & > span
    text-align left
    display flex
    label
      margin-bottom: 0
      padding-top 0
      margin-left 0.5rem
      cursor pointer
      font-weight 300
      text-transform none
      font-size 15px
</style>



// WEBPACK FOOTER //
// Checkbox.vue?511f8636